<template>
  <div v-if="userData && userData.Notifications" class="acc-item acc-notifications">
    <b-dropdown ref="dropdown" aria-role="list" class="dropdown-acc-notifications" :mobile-modal="false">
      <template #trigger>
        <b-tooltip position="is-bottom" multilined type="is-dark">
          <button class="is-transparent notifications-w" aria-haspopup="true" aria-controls="dropdown-menu">
            <icon-base width="16" height="20" view-box="0 0 16 20" icon-name="bell"><icon-bell /></icon-base>
            <span class="tag is-small is-danger">
              {{ userData.NotificationsTotalCount }}
            </span>
          </button>
          <template #content>
            <span>{{ $t("Header.Tooltips.Notifications") }}</span>
          </template>
        </b-tooltip>
      </template>

      <b-dropdown-item aria-role="listitem" custom :focusable="false" class="dropdown-item-header">
        <div class="dropdown-close" @click="$refs.dropdown.toggle()">
          <icon-base width="12" height="12" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
        </div>
        <div class="dropdown-title">{{ $t("Header.Notifications.Title", { count: userData.NotificationsTotalCount }) }}</div>
      </b-dropdown-item>
      <b-dropdown-item v-for="notification in userData.Notifications" :key="notification.Id" aria-role="listitem" class="dropdown-item-link" :href="`/Notifications/View/${notification.Id}`">
        {{ notification.Title }}
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" custom class="dropdown-buttons">
        <b-button tag="a" href="/Notifications/Index" expanded>
          <span>{{ $t("Header.Notifications.ViewAll") }}</span>
        </b-button>
        <b-button tag="a" href="/Notifications/Index" expanded>
          <span>{{ $t("Header.Notifications.ViewSponsoredChannelNotifications") }}</span>
        </b-button>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { UserData } from "@/models/UserData";
import IconBase from "../IconBase.vue";
import IconBell from "../icons/IconBell.vue";
import IconTimes from "../icons/IconTimes.vue";
import i18n from "@/i18n";

const namespace = "mainModule";

@Component({
  components: {
    IconBase,
    IconBell,
    IconTimes,
  },
})
export default class HeaderNotifications extends Vue {
  //#region Vuex getters and actions

  @Getter("userData", { namespace }) userData!: UserData;

  //#endregion Vuex getters and actions

  //#region Getters
 
  //#endregion Getters

  public accNotifications = false;
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.acc-item.acc-notifications {
  display: flex;
  align-items: stretch;
  @media (max-width: 1599px) {
  }
  @media (max-width: 991px) {
  }
  .notifications-w {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    // padding: 0 25px;
    // @media (max-width: 1599px) {
    //   padding: 0 15px;
    // }
    // @media (max-width: 991px) {
    //   padding: 0 5px;
    // }
    .icon-w {
      line-height: 0;
    }
  }
  .tag.is-small {
    position: absolute;
    left: 50%;
    margin-left: 1px;
    top: -6px;
    height: 19px;
    border: 2px solid #fff;
    border-radius: 4px;
    padding: 0 2px;
    width: auto;
  }

  .dropdown-menu {
    margin-top: 10px;
    right: auto;
    left: -28px;
    width: 264px;
    @media (max-width: 991px) {
      left: auto;
      right: -74px;
      width: 305px;
    }
    .dropdown-content {
      border: 1px solid #d3d6e2;
      padding: 0;
      border-radius: 4px;
      position: relative;
      box-shadow: 0px 0px 12px rgba(30, 39, 44, 0.3);
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: 33px;
        top: -8px;
        border-width: 0 7px 8px;
        border-style: solid;
        border-color: transparent transparent #f5f5f5;
        z-index: 2;
        @media (max-width: 991px) {
          left: auto;
          right: 79px;
        }
      }
      &:after {
        content: "";
        display: block;
        position: absolute;
        left: 33px;
        top: -9px;
        border-width: 0 7px 8px;
        border-style: solid;
        border-color: transparent transparent rgba(0, 0, 0, 0.2);
        z-index: 1;
        @media (max-width: 991px) {
          left: auto;
          right: 79px;
        }
      }
    }
  }
  .dropdown-item {
    &.dropdown-item-header {
      background: #f5f5f5;
      border-radius: 4px 4px 0 0;
      border-bottom: 1px solid #d3d6e2;
      font-weight: 600;
      .dropdown-close {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 37px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .icon-w {
        }
      }
    }

    &.dropdown-item-link {
      font-size: 13px;
      padding: 8px 0;
      margin: 0 15px;
      width: auto;
      border-bottom: 1px solid #d3d6e2;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 991px) {
        margin: 0;
        padding: 8px 15px;
      }

      &:hover {
        background: none;
        opacity: 0.8;
      }
    }
    &.dropdown-buttons {
      padding: 13px 15px 21px;
      .button {
        height: 35px;
        &:not(:last-child) {
          margin-bottom: 13px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
html[dir="ltr"] {
  .acc-item.acc-notifications {
    .dropdown-item {
      &.dropdown-item-header {
        .dropdown-close {
          left: auto;
          right: 0;
        }
      }
    }
  }
}
</style>
